import {
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Empty,
  Modal,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../utils/context/UserContext";
import { getDailyStocksReportAPI } from "../../utils/api/ReportsAPI";
import DailyStocksDefaultType from "../../utils/types/DailyStocksDefaultType";
import { GlobalContext } from "../../App";
import {
  SUCCESS_NOTIFICATION_TYPE,
  WARNING_NOTIFICATION_TYPE,
} from "../../utils/api/_ConstantsAPI";
import { PrinterFilled } from "@ant-design/icons";
import { PDFViewer } from "@react-pdf/renderer";
import DailyStocksReportPrint from "../../components/PDFDocuments/DailyStocksReportPrint";
import { getDsrExpenseTableHeader } from "../../utils/tableData/Outlet/DsrExpenseHeader";
import { getDsrAddOnsTableHeader } from "../../utils/tableData/Outlet/DsrAddOnsHeader";

export default function DailyStocksReport() {
  const { profile } = useContext(UserContext);
  const { openNotification } = useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [localDailyStocksReport, setLocalDailyStocksReport] = useState(
    DailyStocksDefaultType
  );

  const [localExpenseList, setLocalExpenseList] = useState([]);
  const [localAddOnsList, setLocalAddOnsList] = useState([]);
  const [localDenomData, setLocalDenomData] = useState([]);
  const [localDataPrint, setLocalDataPrint] = useState([]);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [isRequesting, setIsRequesting] = useState(false);

  const tableContents = localExpenseList.map((data, index) => ({
    ...data,
    key: index,
  }));

  const tableContentsAddOns = localAddOnsList.map((data, index) => ({
    ...data,
    key: index,
  }));

  const formatNum = (val) =>
    parseFloat(val || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const denominationData = Object.entries(localDenomData).map(
    ([key, value]) => {
      const denom = parseFloat(key); // denomination (1000, 500, etc.)
      const qty = parseFloat(value); // quantity
      const amount = denom * qty; // compute amount

      return {
        key,
        denomination: formatNum(denom),
        quantity: formatNum(qty),
        amount: formatNum(amount),
        amount_grand: amount,
      };
    }
  );
  const columnsDenominations = [
    {
      title: "Denomination",
      dataIndex: "denomination",
      key: "denomination",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
    },
  ];

  const grandTotal = denominationData.reduce(
    (sum, row) => sum + row.amount_grand,
    0
  );

  const getDailyStocksReport = async () => {
    setIsLoading(true);
    const res = await getDailyStocksReportAPI(
      selectedDate,
      selectedDateTo,
      profile.branchCode
    );
    if (res.isSuccess) {
      console.log(res.dsr.expense_list);
      setLocalExpenseList(res.dsr?.expense_list);
      setLocalAddOnsList(res.dsr?.addons_list);
      setLocalDenomData(res.dsr?.denomination_list);

      setLocalDailyStocksReport(res.dsr);
      setLocalDataPrint(res.dsr);

      openNotification(
        SUCCESS_NOTIFICATION_TYPE,
        "Daily stocks report",
        `Showing daily stocks report from ${selectedDate} to ${selectedDateTo}!`
      );
    } else {
      openNotification(
        WARNING_NOTIFICATION_TYPE,
        "Daily stocks report",
        "Something went wrong!"
      );
    }
    setIsLoading(false);
  };

  const columnsVoucher = [
    { title: "NO.", dataIndex: "no", key: "no" },
    { title: "VOUCHER #", dataIndex: "voucherNo", key: "voucherNo" },
    {
      title: "AMOUNT",
      dataIndex: "amount",
      key: "amount",
      render: (val) => `₱ ${val}`,
    },
  ];

  // const columnsDenominations = [
  //   { title: "DENOMINATION", dataIndex: "denomination", key: "denomination" },
  //   { title: "PCS", dataIndex: "pcs", key: "pcs" },
  //   {
  //     title: "AMOUNT",
  //     dataIndex: "amount",
  //     key: "amount",
  //     render: (val) => `₱ ${val}`,
  //   },
  // ];

  return (
    <Content>
      <Typography.Title level={3}>C-101 Final Summary Report</Typography.Title>
      <Row className="mb-3">
        <Col sm={18} xs={24} className="text-start">
          <Space.Compact>
            <DatePicker
              onChange={(_, dateString) => setSelectedDate(dateString)}
              format="YYYY-MM-DD"
              disabled={isLoading}
            />
            <DatePicker
              onChange={(_, dateString) => setSelectedDateTo(dateString)}
              format="YYYY-MM-DD"
              disabled={isLoading}
            />
            <Button
              type="primary"
              disabled={isLoading || selectedDate === ""}
              onClick={getDailyStocksReport}
            >
              Process
            </Button>
          </Space.Compact>
        </Col>
        <Col sm={6} xs={24}>
          <Button
            block
            icon={<PrinterFilled />}
            onClick={() => setIsPrintModalOpen(true)}
            disabled={localDailyStocksReport?.date === null || isLoading}
          >
            Print
          </Button>
        </Col>
      </Row>

      <Card bordered>
        {localDailyStocksReport.date !== null ? (
          <>
            <Descriptions bordered size="small" column={2}>
              <Descriptions.Item label="Cashier">
                {`${profile.firstName} ${profile.lastName}`}
              </Descriptions.Item>
              <Descriptions.Item label="Date">
                {selectedDate} - {selectedDateTo}
              </Descriptions.Item>

              <Descriptions.Item label="Opening Grandtotal Sales">
                ₱ {formatNum(localDailyStocksReport.oldgt)}
              </Descriptions.Item>
              <Descriptions.Item label="Closing Grandtotal Sales">
                ₱ {formatNum(localDailyStocksReport.newgt)}
              </Descriptions.Item>

              <Descriptions.Item label="Opening Inventory">
                {localDailyStocksReport.oldinventory}
              </Descriptions.Item>
              <Descriptions.Item label="Closing Inventory">
                {localDailyStocksReport.newinventory}
              </Descriptions.Item>

              <Descriptions.Item label="OPR-R" span={2}>
                {localDailyStocksReport.retail_or_start} -{" "}
                {localDailyStocksReport.retail_or_end}
              </Descriptions.Item>

              <Descriptions.Item label="SALES IN KG">
                {formatNum(localDailyStocksReport.oprRetailKg)}
              </Descriptions.Item>
              <Descriptions.Item label="SALES IN PESO">
                ₱ {formatNum(localDailyStocksReport.oprRetailSales)}
              </Descriptions.Item>

              <Descriptions.Item label="OPR-D" span={2}>
              {localDailyStocksReport.dealer_or_start} -{" "}
                {localDailyStocksReport.dealer_or_end}
              </Descriptions.Item>

              <Descriptions.Item label="SALES IN KG">
                ₱ {localDailyStocksReport.oprDealerKg}
              </Descriptions.Item>
              <Descriptions.Item label="SALES IN PESO">
                ₱ {formatNum(localDailyStocksReport.oprDealerSales)}
              </Descriptions.Item>

              <Descriptions.Item label="TOTAL" span={2}>
                ₱ {formatNum(localDailyStocksReport.totalSales)}
              </Descriptions.Item>
              <Descriptions.Item label="ADD ONS">
                ₱ {formatNum(localDailyStocksReport.total_addons)}
              </Descriptions.Item>
              <Descriptions.Item label="LESS">
                ₱ {formatNum(localDailyStocksReport.total_expenses)}
              </Descriptions.Item>
              <Descriptions.Item label="TOTAL ONLINE" span={2}>
                ₱ {formatNum(localDailyStocksReport.total_online)}
              </Descriptions.Item>
              <Descriptions.Item label="TOTAL CASH" span={2}>
                ₱ {formatNum(localDailyStocksReport.totalSales - localDailyStocksReport.total_expenses - localDailyStocksReport.total_online)}
              </Descriptions.Item>
            </Descriptions>

            <Typography.Title level={5} className="mt-4">
              Daily Less on Sales
            </Typography.Title>
            {/* <Table
              dataSource={getDsrExpenseTableHeader}
              columns={tableContents}
              size="small"
              bordered="true"
              scroll={{ x: true }}
              loading={isRequesting}
              
            /> */}

            <Table
              columns={getDsrExpenseTableHeader()}
              dataSource={tableContents}
              size="small"
              bordered="true"
              scroll={{ x: true }}
              loading={isRequesting}
            />

            <Typography.Title level={5} className="mt-4">
              Add Ons
            </Typography.Title>

            <Table
              columns={getDsrAddOnsTableHeader()}
              dataSource={tableContentsAddOns}
              size="small"
              bordered="true"
              scroll={{ x: true }}
              loading={isRequesting}
            />

            {/* <Typography.Title level={5} className="mt-4">
              Cash Denominations
            </Typography.Title>
            <Table
              dataSource={denominationData}
              columns={columnsDenominations}
              pagination={false}
              size="small"
              bordered
            /> */}

            <Typography.Title level={5} className="mt-4">
              Cash Denominations
            </Typography.Title>
            <Table
              dataSource={denominationData}
              columns={columnsDenominations}
              pagination={false}
              size="small"
              bordered
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={2} align="right">
                    <strong>Grand Total</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} align="right">
                    <strong>{formatNum(grandTotal)}</strong>
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />

            <Row justify="space-between" className="mt-5">
              <Col>
                <Typography.Text>ENCODER: ___________________</Typography.Text>
              </Col>
              <Col>
                <Typography.Text>CASHIER: ___________________</Typography.Text>
              </Col>
              <Col>
                <Typography.Text>AUDITOR: ___________________</Typography.Text>
              </Col>
            </Row>
          </>
        ) : (
          <Empty />
        )}
      </Card>

      <Modal
        centered
        closable={false}
        open={isPrintModalOpen}
        confirmLoading={isLoading}
        onCancel={() => setIsPrintModalOpen(false)}
        cancelText="Close"
        okButtonProps={{ hidden: true }}
        width={"90vw"}
      >
        <PDFViewer style={{ width: "100%", height: "100vh" }}>
          <DailyStocksReportPrint
            dsr={localDailyStocksReport}
            profile={profile}
          />
        </PDFViewer>
      </Modal>
    </Content>
  );
}
